import { Crisp } from 'crisp-sdk-web';

/** Opens the Crisp support chat. The widget stays hidden until something asks for it. */
export function openSupportChat(): void {
  Crisp.chat.show();
  Crisp.chat.open();
}
